export default __webpack_public_path__ + "static/media/MYRIADPRO-REGULAR.d30b0546.otf";